<int-default-input
  [type]="appearance"
  [placeholder]="placeholder"
  [label]="label"
  [showLabelTip]="showLabelTip"
  [readonly]="readonly"
  [autocomplete]="autocomplete"
  [hideField]="hideField"
  [value]="(value$ | async) || ''"
  [name]="name"
  (changeValueEvent)="onChange($event)"
  (onBlurEvent)="onBlur()"
  (onFocusEvent)="onFocus()"
>
  <ng-container ngProjectAs="right-position">
    <div class="action" (click)="changeAppearance($event)">
      <span class="divider"></span>
      <int-icon [name]="iconName" size="1.5rem"></int-icon>
    </div>
  </ng-container>
</int-default-input>
